import React, { useEffect } from 'react';
import SiteNav, { GAMES_NAV_LINKS } from '../components/SiteNav';
import useNavSolid from '../hooks/useNavSolid';
import { GAMES } from '../data/games';
import { PUBLIC_SITE_ORIGIN } from '../config';
import ParentNewsletterCta from '../components/ParentNewsletterCta';

export default function GamesPage() {
  const navSolid = useNavSolid(24);

  useEffect(() => {
    document.title = 'Play & Discover — Libby the Lion & Friends';
    const canonical = `${PUBLIC_SITE_ORIGIN}/games`;
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', canonical);
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', canonical);
  }, []);

  return (
    <div className="v2-shell games-shell">
      <SiteNav solid={navSolid} links={GAMES_NAV_LINKS} brandHref="/" />
      <header className="games-hero">
        <div className="games-hero__inner">
          <p className="section-eyebrow">Happy Tree Valley</p>
          <h1 className="section-display">Play &amp; Discover</h1>
          <p className="games-hero__lead">
            Color with Libby and friends, or join Detective Tully on gentle hidden-object adventures — right in your
            browser.
          </p>
        </div>
      </header>

      <main className="games-main">
        <ul className="games-grid">
          {GAMES.map(game => (
            <li key={game.id}>
              <article
                className={[
                  'games-card',
                  game.id === 'detective-tully' && 'games-card--detective-tully',
                  game.id === 'color-with-me' && 'games-card--color-with-me',
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                <a href={`/play/${game.id}`} className="games-card__media">
                  <img
                    src={game.thumbSrc}
                    alt={game.thumbAlt}
                    className="games-card__thumb"
                    width={1280}
                    height={720}
                    decoding="async"
                  />
                </a>
                <div className="games-card__body">
                  <p className="section-eyebrow games-card__kicker">{game.kicker}</p>
                  <h2 className="games-card__title">
                    <a href={`/play/${game.id}`}>{game.title}</a>
                  </h2>
                  <p className="games-card__desc">{game.description}</p>
                  <a
                    href={`/play/${game.id}`}
                    className={[
                      'games-btn',
                      'games-card__play',
                      game.playBtnVariant && `games-btn--${game.playBtnVariant}`,
                    ]
                      .filter(Boolean)
                      .join(' ')}
                  >
                    Play now
                  </a>
                  <p className="games-card__footnote">
                    <a href={game.standaloneSrc} target="_blank" rel="noopener noreferrer">
                      Open in a new tab
                    </a>
                  </p>
                </div>
              </article>
            </li>
          ))}
        </ul>
        <p className="games-note">
          Progress is saved in this browser on {PUBLIC_SITE_ORIGIN.replace(/^https?:\/\//, '')}. Grown-ups can back up
          or restore from the gear menu inside the game.
        </p>
        <ParentNewsletterCta variant="games" />
      </main>

      <footer className="v2-footer games-footer">
        <div className="footer-title-band">
          <p className="footer-line">
            <a href="/">← Back to Libby the Lion &amp; Friends</a>
          </p>
        </div>
      </footer>
    </div>
  );
}
